/* Manu AI v22 (22/10/2026) — trois usages clairs pour une image ajoutée : l'imprimer telle quelle, s'en inspirer, la COPIER fidèlement.
 * - « + Image » (accueil) : troisième choix « Copier mon logo » ; le chat propose aussi « La copier » après une pièce jointe.
 * - Copie : petit formulaire (ce qu'il faut changer, face, attestation « c'est mon logo / j'ai le droit »), puis le logo part au serveur
 *   avec `base` + `edit` + `copy` + `rights` (api/studio.js, fidélité haute, aucun garde-fou de copie).
 * - Le résultat est un design Manu : « Refaire » et « Décliner » (équipes) fonctionnent ensuite, sans garde-fou de copie.
 * S'appuie sur section._ais enrichie par v9 → v21 (v15 : s.edit1 / apiLogo). */
(function () {
  'use strict';

  var TXT = {
    fr: { add: 'Copier mon logo', add_d: 'Copie fidèle, avec la modification de ton choix (nom, couleur…)', chip: 'La copier fidèlement',
      lead: 'Je recopie ton logo à l’identique, avec uniquement la modification que tu demandes.', what: 'Qu’est-ce que je change ? (facultatif)', ph: 'Ex. : remplace le nom par TEAM X',
      face: 'Où l’imprimer ?', front: 'Devant', back: 'Dos', rights: 'C’est mon logo, ou j’ai le droit de l’utiliser.', go: 'Copier mon logo', print: 'Plutôt l’imprimer telle quelle', insp: 'Plutôt m’en inspirer',
      none: 'Reproduce it exactly, with no change.', msg: 'Copie mon logo', bad: 'Image non lisible : PNG, JPG ou WebP, 15 Mo maximum.', need: 'Coche la case pour continuer.' },
    en: { add: 'Copy my logo', add_d: 'Faithful copy, with the change of your choice (name, colour…)', chip: 'Copy it faithfully',
      lead: 'I redraw your logo exactly, changing only what you ask.', what: 'What should I change? (optional)', ph: 'E.g. replace the name with TEAM X',
      face: 'Where to print it?', front: 'Front', back: 'Back', rights: 'This is my logo, or I have the right to use it.', go: 'Copy my logo', print: 'Print it as is instead', insp: 'Use it as inspiration instead',
      none: 'Reproduce it exactly, with no change.', msg: 'Copy my logo', bad: 'Unreadable image: PNG, JPG or WebP, 15 MB max.', need: 'Tick the box to continue.' },
    es: { add: 'Copiar mi logo', add_d: 'Copia fiel, con el cambio que quieras (nombre, color…)', chip: 'Copiarla fielmente',
      lead: 'Redibujo tu logo idéntico, cambiando solo lo que pidas.', what: '¿Qué cambio? (opcional)', ph: 'Ej.: cambia el nombre por TEAM X',
      face: '¿Dónde imprimirlo?', front: 'Delante', back: 'Espalda', rights: 'Es mi logo, o tengo derecho a usarlo.', go: 'Copiar mi logo', print: 'Mejor imprimirla tal cual', insp: 'Mejor inspirarme en ella',
      none: 'Reproduce it exactly, with no change.', msg: 'Copia mi logo', bad: 'Imagen ilegible: PNG, JPG o WebP, 15 MB como máximo.', need: 'Marca la casilla para continuar.' },
    de: { add: 'Mein Logo kopieren', add_d: 'Originalgetreue Kopie mit der gewünschten Änderung (Name, Farbe …)', chip: 'Originalgetreu kopieren',
      lead: 'Ich zeichne dein Logo exakt nach und ändere nur, was du möchtest.', what: 'Was soll ich ändern? (optional)', ph: 'Z. B. Name durch TEAM X ersetzen',
      face: 'Wohin drucken?', front: 'Vorne', back: 'Rücken', rights: 'Das ist mein Logo, oder ich darf es verwenden.', go: 'Mein Logo kopieren', print: 'Lieber unverändert drucken', insp: 'Lieber als Inspiration nutzen',
      none: 'Reproduce it exactly, with no change.', msg: 'Kopiere mein Logo', bad: 'Bild nicht lesbar: PNG, JPG oder WebP, max. 15 MB.', need: 'Hake das Kästchen an, um fortzufahren.' },
    it: { add: 'Copia il mio logo', add_d: 'Copia fedele, con la modifica che vuoi (nome, colore…)', chip: 'Copiarla fedelmente',
      lead: 'Ridisegno il tuo logo identico, cambiando solo ciò che chiedi.', what: 'Cosa cambio? (facoltativo)', ph: 'Es.: sostituisci il nome con TEAM X',
      face: 'Dove stamparlo?', front: 'Davanti', back: 'Dietro', rights: 'È il mio logo, o ho il diritto di usarlo.', go: 'Copia il mio logo', print: 'Meglio stamparla così', insp: 'Meglio ispirarmi',
      none: 'Reproduce it exactly, with no change.', msg: 'Copia il mio logo', bad: 'Immagine illeggibile: PNG, JPG o WebP, max 15 MB.', need: 'Spunta la casella per continuare.' }
  };
  var IC = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 012-2h9"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readUrl(file) { return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(file); }); }
  function shrink(src, max) {
    return new Promise(function (res, rej) {
      var i = new Image();
      i.onload = function () {
        var w = i.naturalWidth || 800, h = i.naturalHeight || 800, k = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        var x = c.getContext('2d'); x.drawImage(i, 0, 0, c.width, c.height);
        var d = x.getImageData(0, 0, c.width, c.height).data, alpha = false;
        for (var n = 3; n < d.length; n += 16) if (d[n] < 250) { alpha = true; break; }
        res({ url: alpha ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.88), w: c.width, h: c.height });
      };
      i.onerror = rej; i.src = src;
    });
  }
  function valid(f) { return f && (/^image\/(png|jpe?g|webp)$/i.test(f.type)) && f.size <= 15 * 1024 * 1024; }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v22) return;
    inst._v22 = true;
    var t = TXT[inst.loc] || TXT.en;

    /* ---------- Formulaire de copie (dans le fil) ---------- */
    inst.copyForm = function (img) {
      var self = this, s = this.s, side0 = img.h / img.w > 0.6 ? 'back' : 'front', uid = 'cp' + Date.now();
      this.lockThread();
      return this.bot(
        '<form class="ais-cp" novalidate>' +
          '<p class="ais-cp__lead">' + esc(t.lead) + '</p>' +
          '<label class="ais-cp__l" for="' + uid + 't">' + esc(t.what) + '</label>' +
          '<input class="ais-cp__in" id="' + uid + 't" type="text" maxlength="300" placeholder="' + esc(t.ph) + '" value="' + esc(img.text || '') + '">' +
          // 23/10/2026 : plus de choix « Où l'imprimer ? » : la face est proposée d'après le format de l'image (large → devant, haute ou carrée → dos), le client règle ensuite sur le mockup
          '<label class="ais-cp__rights"><input type="checkbox" data-cp-rights><span>' + esc(t.rights) + '</span></label>' +
          '<p class="ais-cp__hint" role="status" hidden>' + esc(t.need) + '</p>' +
          '<div class="ais-cp__act"><button type="submit" class="ais-btn ais-cp__go">' + esc(t.go) + '</button>' +
            '<button type="button" class="ais-cp__alt" data-cp-alt="img-print">' + esc(t.print) + '</button>' +
            '<button type="button" class="ais-cp__alt" data-cp-alt="img-inspire">' + esc(t.insp) + '</button></div>' +
        '</form>', true
      ).then(function (box) {
        var f = box.querySelector('form'), hint = f.querySelector('.ais-cp__hint'), rights = f.querySelector('[data-cp-rights]');
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!rights.checked) { hint.hidden = false; rights.focus(); return; }
          var side = side0, text = f.querySelector('.ais-cp__in').value.trim();
          Array.prototype.forEach.call(f.elements, function (el) { el.disabled = true; });
          self.copyGo(img, side, text);
        });
        rights.addEventListener('change', function () { if (rights.checked) hint.hidden = true; });
        f.addEventListener('click', function (e) {
          var b = e.target.closest('[data-cp-alt]'); if (!b) return;
          Array.prototype.forEach.call(f.elements, function (el) { el.disabled = true; });
          self.attached = img; self.command(b.getAttribute('data-cp-alt'), null, b.textContent);
        });
        if (window.matchMedia('(min-width: 750px)').matches) f.querySelector('.ais-cp__in').focus({ preventScroll: true });
      });
    };

    /* ---------- Lancement : la copie part comme une retouche (v15) avec copy + rights ---------- */
    inst.copyGo = function (img, side, text) {
      var s = this.s;
      this.user(t.msg + (text ? ' : ' + text : ''));
      s.path = 'story'; s.idea = s.idea || t.msg; s.sides = side; s.zonesOk = true; s.pending = null;
      s.edit1 = { side: side, text: (text || t.none).slice(0, 300), base: img.big, copy: true };
      if (this.track) this.track('image_choice', { use: 'copy', side: side });
      this.attached = null; this.quick.innerHTML = ''; this.resultEl = null;
      this.generateFaces([side], false);
    };

    /* ---------- Entrées : menu « + Image » de l'accueil, puce du chat ---------- */
    inst.copyImage = function (file) {
      var self = this;
      if (!valid(file)) { this.open({ path: 'story', own: true }); this.s.pending = 'idea'; this.bot(esc(t.bad)); return; }
      if (!this.endpoint) return this.ownFile(file, 'front', true); // démo sans serveur : impression telle quelle
      this.open({ path: 'story', own: true });
      this.busy = true;
      readUrl(file).then(function (url) { return Promise.all([shrink(url, 768), shrink(url, 1024)]); }).then(function (r) {
        self.busy = false;
        self._tagNext = true; self.user(t.msg);
        var msgs = self.thread.querySelectorAll('.ais-msg--user'), last = msgs[msgs.length - 1];
        if (last) last.insertAdjacentHTML('beforeend', '<img class="ais-msg__img" src="' + esc(r[0].url) + '" alt="">');
        self.copyForm({ file: file, small: r[0].url, big: r[1].url, w: r[1].w, h: r[1].h, text: '' });
      }, function () { self.busy = false; self.bot(esc(t.bad)); });
    };

    var baseChips = inst.chips;
    inst.chips = function (opts) {
      if (opts && opts.length === 2 && opts.some(function (o) { return o.cmd === 'img-print'; }) && opts.some(function (o) { return o.cmd === 'img-inspire'; })) {
        opts = opts.concat([{ cmd: 'img-copy', l: t.chip, ghost: true }]);
      }
      return baseChips.call(this, opts);
    };
    var baseCmd = inst.command;
    inst.command = function (cmd, value, label) {
      if (cmd === 'img-copy') {
        var att = this.attached; if (!att) return;
        this.user(label); this.quick.innerHTML = '';
        return this.copyForm(att);
      }
      return baseCmd.apply(this, arguments);
    };

    // Menu « + Image » (v12) : troisième choix. Posé sur chaque menu présent ET sur ceux recréés plus tard (accueil refait, autre gabarit) :
    // avant, seul le menu existant au chargement l'avait et la copie manquait sur certains téléphones.
    function addCopyItem(pop) {
      if (!pop || pop.querySelector('[data-v22-copy]')) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ais-addopt'; b.setAttribute('data-v22-copy', '');
      b.innerHTML = '<span class="ais-addopt__ic">' + IC + '</span><span class="ais-addopt__txt"><b>' + esc(t.add) + '</b><small>' + esc(t.add_d) + '</small></span>';
      var fi = document.createElement('input'); fi.type = 'file'; fi.className = 'ais-vh'; fi.tabIndex = -1; fi.accept = 'image/png,image/jpeg,image/webp';
      pop.appendChild(b); pop.appendChild(fi);
      b.addEventListener('click', function () { pop.hidden = true; var w = pop.closest('[data-v11-add]'); if (w) { w.classList.remove('is-open'); var bt = w.querySelector('.ais-addbtn'); if (bt) bt.setAttribute('aria-expanded', 'false'); } fi.click(); });
      fi.addEventListener('change', function () { var f = fi.files && fi.files[0]; fi.value = ''; if (f) inst.copyImage(f); });
    }
    // v28f · sur mobile, placeIntro (ai-studio.js) déplace l'accroche + le formulaire d'accueil dans le bloc vidéo du hero,
    // HORS de root : on cherche donc aussi dans le formulaire d'accueil (inst.form) et on l'observe là où il se trouve.
    function addAll() {
      Array.prototype.forEach.call(root.querySelectorAll('.ais-addpop'), addCopyItem);
      if (inst.form && !root.contains(inst.form)) Array.prototype.forEach.call(inst.form.querySelectorAll('.ais-addpop'), addCopyItem);
    }
    addAll();
    if (window.MutationObserver) {
      var mo = new MutationObserver(addAll);
      mo.observe(root, { childList: true, subtree: true });
      if (inst.form && !root.contains(inst.form)) mo.observe(inst.form, { childList: true, subtree: true });
    }
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      if (root._ais && root._ais._v15 && root._ais._v12) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
